"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/// <param name="t_wb">Wet-bulb [°C_wb]</param>
/// <param name="W">Humidity Ratio [kg/kg]</param>
/// <param name="airPressure">Pressure [Pa]</param>
/// <returns>Temperature [°C]</returns>
// tslint:disable-next-line:variable-name
function ASHRAE2009_GetGuessForDryBulb_GivenWetBulbAndHumidityRatio(airPressure, W, t_wb) {
    // ASHRAE 2009 Handbook - Fundamentals (SI)
    // 1.9 THERMODYNAMIC WET-BULB AND DEW-POINT TEMPERATURE
    // Formulas (35) and (37)
    //double W = w.ValueAs(Units.KilogramPerKilogram);
    // tslint:disable-next-line:variable-name
    var t_star = t_wb;
    // tslint:disable-next-line:variable-name
    var Pw_star = ASHRAE2009_CalculateWaterVaporSaturationPressure(t_wb);
    // tslint:disable-next-line:variable-name
    var Ws_star = CalculateHumidityRatio(Pw_star, airPressure);
    var alpha;
    var beta;
    if (t_wb < 0.0) {
        alpha = (2830 - 0.24 * t_star) * Ws_star;
        beta = (2830 - 2.1 * t_star) * W;
    }
    else {
        alpha = (2501 - 2.326 * t_star) * Ws_star;
        beta = (2501 - 4.186 * t_star) * W;
    }
    var t = (alpha - beta + 1.006 * t_star) / (1.86 * W + 1.006);
    return t;
}
exports.ASHRAE2009_GetGuessForDryBulb_GivenWetBulbAndHumidityRatio = ASHRAE2009_GetGuessForDryBulb_GivenWetBulbAndHumidityRatio;
/// <param name="p_w">Pressure [Pa]</param>
/// <param name="p">Pressure [Pa]</param>
/// <returns>Humidity Ratio [kg/kg]</returns>
// tslint:disable-next-line:variable-name
function CalculateHumidityRatio(p_w, p) {
    // ASHRAE 2009 Handbook - Fundamentals (SI)
    // 1.8 PERFECT GAS RELATIONSHIPS FOR DRY AND MOIST AIR
    // Formula (22)
    // Pw, the partial pressure of water vapor in moist air [Pa]
    // P, total (barometric) pressure of moist air [Pa]
    // Constants
    var molecularMassRatio = 18.015268 / 28.966; // between water and dry air
    var W = molecularMassRatio * p_w / (p - p_w);
    return W;
}
exports.CalculateHumidityRatio = CalculateHumidityRatio;
/// <param name="t">Temperature [°C]</param>
/// <returns>Pressure [Pa]</returns>
function ASHRAE2009_CalculateWaterVaporSaturationPressure(t) {
    // ASHRAE 2009 Handbook - Fundamentals (SI)
    // 1.2 THERMODYNAMIC PROPERTIES OF WATER AT SATURATION
    // Formulas (5) and (6)
    // Constants
    var C1 = -5674.5359;
    var C2 = 6.3925247;
    var C3 = -0.009677843;
    var C4 = 0.00000062215701;
    var C5 = 0.0000000020747825;
    var C6 = -0.0000000000009484024;
    var C7 = 4.1635019;
    var C8 = -5800.2206;
    var C9 = 1.3914993;
    var C10 = -0.048640239;
    var C11 = 0.000041764768;
    var C12 = -0.000000014452093;
    var C13 = 6.5459673;
    var lnpws;
    var T = t + 273.15; // [°C] -> [K]
    if (t <= 0.0) {
        lnpws = C1 / T + C2 + C3 * T + C4 * Math.pow(T, 2.0) + C5 * Math.pow(T, 3.0) + C6 * Math.pow(T, 4.0) + C7 * Math.log(T);
    }
    else {
        lnpws = C8 / T + C9 + C10 * T + C11 * Math.pow(T, 2.0) + C12 * Math.pow(T, 3.0) + C13 * Math.log(T);
    }
    return Math.exp(lnpws);
}
exports.ASHRAE2009_CalculateWaterVaporSaturationPressure = ASHRAE2009_CalculateWaterVaporSaturationPressure;
